import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from '../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { KieneTableService } from '../components/kiene-table/kiene-table.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

@Component({ selector: 'app-home', templateUrl: './home.component.html', styleUrls: ['./home.component.scss'] })
export class HomeComponent implements OnInit {
    isKunde = true;

    currentTab: string;
    currentTabIndex = 0;

    tierarztId = 0;

    constructor(
        private localStorageService: LocalStorageService,
        private api: KieneTableService,
        public dialog: MatDialog,
        private route: ActivatedRoute,
    ) {
        this.localStorageService.setCurrentClientVisible(false);
        if (this.localStorageService.hasPermission(1771) || this.localStorageService.hasPermission(1082)) {
            this.localStorageService.setShoppingCartVisible(true, 'HomeComponent');
        }
        this.tierarztId = this.localStorageService.getCurrentUser().tierarzt_id;

        this.currentTab = this.route.snapshot.queryParamMap.get('tab');
        if (this.currentTab) {
            if (this.currentTab === 'tourenplan') {
                this.currentTabIndex = 0;
            } else if (this.currentTab === 'information') {
                this.currentTabIndex = 1;
            } else if (this.currentTab === 'meinbestand') {
                this.currentTabIndex = 2;
            } else if (this.currentTab === 'fortbildungen') {
                if (this.currentUserIsVet()) {
                    this.currentTabIndex = 3;
                } else {
                    this.currentTabIndex = 2;
                }
            } else if (this.currentTab === 'urlaubskalender') {
                this.currentTabIndex = 4;
            } else if (this.currentTab === 'wochenendplaner') {
                this.currentTabIndex = 5;
            } else {
                this.currentTabIndex = 0;
            }
        }
    }

    ngOnInit() {
        this.isKunde = this.localStorageService.isCurrentUserKunde();
    }

    currentUserIsVet() {
        return this.localStorageService.getCurrentUser()?.tierarzt_id;
    }

    isTabMenuVisible(path: string) {
        return this.localStorageService.currentUserCanSeeTab(path);
    }
}

const STARTSEITE_TABS = [
    'tourenplan',
    'infos-tourenplan',
    'mein-bestand',
    'fortbildungen',
    'urlaubskalender',
    'wochenendplaner',
];

@Component({ selector: 'app-startseite-einstieg', template: '' })
export class StartseiteEinstiegComponent implements OnInit {
    constructor(
        private readonly router: Router,
        private readonly localStorageService: LocalStorageService,
    ) {}

    ngOnInit() {
        const tab = STARTSEITE_TABS.find(name => this.localStorageService.currentUserCanSeeTab('/startseite/' + name));
        if (tab) {
            this.router.navigate(['/startseite', tab], { replaceUrl: true });
            return;
        }
        const fallback = this.localStorageService.getStartseite();
        if (fallback && fallback !== '/startseite') {
            this.router.navigate([fallback], { replaceUrl: true });
        }
    }
}
